<template>
  <div class="cascader-wrap">
    <div class="cascader">
      <slot name="before" />
      <div
        class="btn"
        @click="showCascader"
      >
        <span
          v-if="valueDesc"
          class="name fs-black"
        >{{ valueDesc }}</span>
        <span
          v-else
          class="name"
        >{{ $t('message["855"]') }} {{ data.is_shared ? $t('message["1727"]') : data.fieldname }}</span>
        <i class="iconfont iconicon-test18" />
      </div>
      <member-invoke
        ref="members"
        :visible="visible"
        :source-datas="sourceDatas || []"
        :default-value="defaultValue"
        :is-must-last="isMustLast"
        :fieldtype="data.fieldtype"
        @change="handleCascaderSub"
        @update="updateShow"
      />
      <slot name="after" />
    </div>
    <cube-validator
      ref="formItem"
      v-model="valid"
      :model="defaultValue"
      :rules="rules"
      :messages="messages"
      :immediate="false"
    />
  </div>
</template>

<script>
import MemberInvoke from '@/components/mobile/Members'
import _ from 'lodash'

export default {
  components: {
    MemberInvoke
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    async: {
      type: Boolean,
      default: false
    },
    getData: {
      type: [Function, Promise],
      default: () => ({})
    },
    value: { // value 需要是对象数组
      type: Array,
      default: () => []
    },
    inputTruename: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      defaultValue: [],
      valueDesc: '',
      sourceDatas: [],
      visible: false,
      divides: {
        1: this.$t('message["299"]'), // 分配到人
        2: this.$i18n.t('message["714"]'), // 平均分配
        3: this.$i18n.t('message["3"]'), // 按额度分配
        4: this.$i18n.t('message["1763"]') // 负责人指派
      },
      valid: undefined,
      rules: {
        required: this.data.isneeded === 1,
        type: 'array',
        custom: this.validateCascader
      },
      messages: {
        custom: ''
      }
    }
  },
  computed: {
    isCreatePage () {
      return this.$route.name === 'InqueryCreate'
    },
    isAuditPage () {
      return this.$route.name === 'InqueryDetail' && this.auditStatus !== 1
    },
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    isMustLast () { // 是否必须选到末级,默认true
      let { isMustLast } = this.data || {}
      if (isMustLast === undefined || isMustLast === true) {
        isMustLast = true
      } else {
        isMustLast = false
      }
      return isMustLast
    }
  },
  watch: {
    value (val) {
      this.defaultValue = val
      setTimeout(() => {
        if (!this.sourceDatas || !val) return

        if (this.data.fieldtype === 'select_reception') {
          this.valueDesc = this.setReceptionValueDesc([], this.sourceDatas)
        } else {
          this.valueDesc = this.setValueDesc({}, [], this.sourceDatas)
        }
      }, 30)
    }
  },

  async created () {
    this.init()
  },
  methods: {
    showCascader () {
      this.visible = true
    },

    handleCascaderSub (result = {}) {
      this.valueDesc = result.text
      this.data.fieldvalue = result.value || []
      this.data.info = _.reduce(this.data.fieldvalue, (res, item) => {
        res[item.keyname] = item.id
        return res
      }, {})
      this.defaultValue = this.data.fieldvalue

      if (this.data.fieldtype === 'select_reception') {
        let value = this.data.fieldvalue.map(o => o.id || undefined)

        this.$set(this.data, 'value', value)
        this.$emit('change', value)
      } else {
        this.$set(this.data, 'value', this.data.fieldvalue)
      }
    },

    updateShow (visible) {
      this.visible = visible
    },

    async loadData () {
      let { fieldkey } = this.data || {}

      const data = await this.getData({ fieldkey })
      if (data) {
        this.sourceDatas = data || []
      }

      // this.valueDesc = this.setValueDesc({}, [], this.sourceDatas)

      this.resetData()
    },

    /** fieldkey === 'dev'
     * 用来过滤不合法的数据（默认值不在列表选项内，包含已离职，转组等情况）
     */
    resetData () {
      let { info = {}, fieldkey } = this.data || {}
      let { userid = 0, groupid = 0, roleid = 0 } = info
      let flag = true
      if (this.defaultValue.length === 1) {
        if ((this.sourceDatas.findIndex(item => item.id === userid)) === -1) {
          this.data.info.userid = 0
        }
      } else if (this.defaultValue.length === 3) {
        let currRoleItem = this.sourceDatas.find(item => item.id === roleid)
        let currGroupItem = currRoleItem && currRoleItem.children.find(item => item.id === groupid)

        if (!currRoleItem) {
          flag = false
        }
        if (currRoleItem && !currGroupItem) {
          flag = false
        }

        if (currGroupItem && currGroupItem.children && currGroupItem.children.findIndex(item => item.id === userid) === -1) {
          flag = false
        }
      }
      if (!flag && fieldkey === 'dev') {
        this.data.info.roleid = 0
        this.data.info.groupid = 0
        this.data.info.userid = 0

        this.data.fieldvalue = []
        this.defaultValue = []

        this.$emit('change', this.data)
      }
    },

    async init () {
      /* sourceDatas */
      if (this.data.fieldtype === 'select_reception') {
        this.sourceDatas = this.data.options || []
      } else {
        await this.loadData()
      }

      /* defaultValue */
      if (this.value && this.value.length) {
        this.defaultValue = this.value
      } else if (this.data.fieldtype === 'cascader') {
        this.defaultValue = this.setDefaultValue()
      } else if (this.data.fieldtype === 'select_reception') {
        // 处理select_reception类型
        this.defaultValue = this.setReceptionDefalutValue(this.data.fieldvalue, this.sourceDatas)
      }

      /* valueDesc */
      if (this.value && this.value.length) {
        this.defaultValue = this.value
        if (this.data.fieldtype === 'select_reception') {
          this.valueDesc = this.setReceptionValueDesc([], this.sourceDatas)
        } else {
          this.valueDesc = this.setValueDesc({}, [], this.sourceDatas)
        }
      } else if (this.data.fieldtype === 'cascader') {
        this.valueDesc = this.setValueDesc({}, [], this.sourceDatas)
      } else if (this.data.fieldtype === 'select_reception') {
        // 处理 select_reception 类型的value显示
        this.valueDesc = this.setReceptionValueDesc([], this.sourceDatas)
      }
      // this.$forceUpdate()
    },

    // TODO: 四级的展示
    setDefaultValue () {
      let arr = []
      const { info = {}, fieldkey } = this.data
      const { divides } = this
      let { roleid = 0, groupid = 0, userid = 0, divide_type: divideType, truename = '', rolename = '', groupname = '' } = info

      // 如果是审核页面
      // 审核页的录入人员不是万能表单
      if ((this.isAuditPage && this.inputTruename.indexOf('万能表单自动录入') === -1) && !roleid && !userid) {
        roleid = 'null'
        rolename = fieldkey === 'dev' ? '-无-' : fieldkey === 'follow' ? '-暂不分配-' : ''
      }

      if (roleid) {
        arr.push({
          keyname: 'roleid',
          id: roleid,
          name: rolename
        })
      }
      if (groupid) {
        arr.push({
          keyname: 'groupid',
          id: groupid,
          name: groupname
        })
      }

      if (divideType === 1 && userid) {
        arr.push({
          keyname: 'divide_type',
          id: divideType,
          name: divides[divideType]
        })
        arr.push({
          keyname: 'userid',
          id: userid,
          name: truename
        })
      } else if (userid && !divideType) {
        arr.push({
          keyname: 'userid',
          id: userid,
          name: truename
        })
      } else if (divideType) {
        arr.push({
          keyname: 'divide_type',
          id: divideType,
          name: divides[divideType]
        })
      }
      this.data.fieldvalue = arr
      return arr
    },

    setValueDesc (res, arr, children) {
      for (let i = 0; i < this.defaultValue.length; i++) {
        for (let one of children) {
          // one.id的值为： null 或者 数字，==勿修改
          if (this.defaultValue[i].keyname === one.keyname && (this.defaultValue[i].id == one.id)) {
            if (!res[one.keyname]) {
              res[one.keyname] = one.name || one.truename
            }
            if (one.children && one.children.length) {
              this.setValueDesc(res, arr, one.children)
            }
          }
        }
      }
      arr = Object.values(res)
      // this.$forceUpdate()
      return arr.join('/')
    },
    setReceptionValueDesc (arr, children) {
      for (let i = 0; i < this.defaultValue.length; i++) {
        for (let one of children) {
          if (this.defaultValue[i] && this.defaultValue[i].id === one.id) {
            if (!arr[i]) {
              arr[i] = one.name
            }
            if (one.children && one.children.length) {
              this.setReceptionValueDesc(arr, one.children)
            }
          }
        }
      }
      return arr.join('/')
    },
    setReceptionDefalutValue (values = [], children = []) {
      let arr = []
      let parentItem = children.find(item => values[0] && item.id === values[0])
      if (parentItem) {
        arr.push({ ...parentItem, keyname: 'fieldkey' })
      }
      if (parentItem && parentItem.children) {
        let childItem = parentItem.children.find(item => values[1] && item.id === values[1])
        if (childItem) {
          arr.push({ ...childItem, keyname: 'fieldkey' })
        }
      }
      return arr
    },

    clearCascader () {
      this.defaultValue = []
      this.data.fieldvalue = []
      this.data.info = {}
      this.valueDesc = ''
    },
    updateFollowOptions (data, isShared) {
      this.sourceDatas = data
      this.data.is_shared = isShared
      this.valueDesc = ''
    },
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    validateCascader () {
      let res = false
      let { fieldname = '', fieldvalue = [], isneeded } = this.data
      if (!isneeded) {
        res = true
      } else if (fieldvalue.length) {
        res = true
      } else {
        let spaceStr = this.$isEnglish ? ' ' : ''
        this.messages.custom = this.$t('message["855"]') + spaceStr + fieldname
        this.messages.required = this.$t('message["855"]') + spaceStr + fieldname
        res = false
      }

      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.cascader-wrap {
  flex: 1;
}
.cascader {
  flex: 1;
  .btn {
    display: flex;
    flex: 1;
    justify-content: space-between;
    color: #d6d6d6;
  }
  .name {
    padding: 12px 0;
    line-height: 1.5;
    align-self: center;
  }

  .iconfont {
    color: #d6d6d6;
  }
}
</style>
